import { render } from "./OrderGuests.vue?vue&type=template&id=0fe6fe3a&scoped=true"
import script from "./OrderGuests.vue?vue&type=script&lang=js"
export * from "./OrderGuests.vue?vue&type=script&lang=js"

import "./OrderGuests.vue?vue&type=style&index=0&id=0fe6fe3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe6fe3a"]])

export default __exports__